import {Pipe, PipeTransform} from '@angular/core';
import moment from "moment";

@Pipe({
  name: 'traspasos',
})
export class TraspasosPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if (items) {

      if (filter) {

        if (filter['dias_atras']) {
          let date = moment().subtract(filter['dias_atras'], 'days').format('YYYY-MM-DD');

          items = items.filter((item) => item.fecha >= date);
        }

        if (!filter['recibidos']) {
          items = items.filter((item) => item.id_estado !== 3);
        }

        if (filter['id_local_origen']) {
          items = items.filter((item) => item.id_local == filter['id_local_origen']);
        }

        if (filter['id_local_destino']) {
          items = items.filter((item) => item.id_local_destino == filter['id_local_destino']);
        }

        if (filter['id_estado']) {
          items = items.filter((item) => item.id_estado == filter['id_estado']);
        }

      }

      return items;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/traspasos/traspasos.ts